// fin-core / labels — what staff read. French, formal. An unknown code is shown AS IT IS, never
// hidden, so that a new blocker cannot disappear from the screen.

const BLOCKERS: Readonly<Record<string, string>> = {
  gate: 'Flux du terminal ou miroir Vega pas à jour',
  export_not_covering: "L'export Vega ne couvre pas ce jour",
  month_not_loaded: "Mois de l'export non chargé",
  control: 'Écart de contrôle sur la journée',
  gap: 'Jour précédent pas encore posté',
  proposals: 'Écritures proposées périmées',
  window_sealed: 'Fenêtre de déclaration déjà scellée',
  before_book_open: "Avant l'ouverture du livre",
  activity_in_closure: 'Activité pendant une fermeture déclarée',
};

const PERIOD_STATES: Readonly<Record<string, string>> = {
  closed: 'Mois clos',
  exported: 'Mois exporté',
};

/** `gate` → « Flux du terminal… ». `period_<state>` → « Mois clos ». Anything else → the code itself. */
export function blockerLabel(code: string): string {
  const known = BLOCKERS[code];
  if (known) return known;
  const period = /^period_(.+)$/.exec(code);
  if (period) return PERIOD_STATES[period[1] ?? ''] ?? `Période ${period[1]}`;
  return code;
}

const DRIFT_KINDS: Readonly<Record<string, string>> = {
  missing: 'Écriture manquante',
  extra: 'Écriture en trop',
  changed: 'Écriture modifiée par Vega',
  pending_correction: 'Correction en attente',
  unknown: 'Écart inexpliqué',
};

export function driftLabel(kind: string): string {
  return DRIFT_KINDS[kind] ?? kind;
}

const OUTCOMES: Readonly<Record<string, string>> = {
  ok: 'terminé',
  blocked: 'arrêté sur un jour bloqué',
  drift: 'écart de dérive',
  error: 'échec',
  skipped_overlap: 'ignoré (un autre passage tournait)',
};

export function outcomeLabel(outcome: string): string {
  return OUTCOMES[outcome] ?? outcome;
}

const JOURNALS: Readonly<Record<string, string>> = {
  VTPMS: 'Ventes',
  BKPMS: 'Banque',
  ANPMS: 'À-nouveaux',
  VTLS: 'Ventes restaurant (Lightspeed)',
  BKLS: 'Encaissements restaurant (Lightspeed)',
  GLPMS: 'Comptabilité générale',
  RCPMS: 'Rapprochement macompta',
};

export function journalLabel(code: string): string {
  return JOURNALS[code] ?? code;
}

/** The book is a rehearsal until the SAS book is the one shown. */
export const TRIAL_BOOK = 'PROOF';
export const TRIAL_BOOK_NOTICE = "Livre d'essai : ce n'est pas la comptabilité officielle";

export const isTrialBook = (book: string): boolean => book === TRIAL_BOOK;
